module.exports = __webpack_public_path__ + "media/images/arrow-up-right-6ec562d7350baf1117b6512fe115dd5d.png";